var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_31_14",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 31 \\u2013 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2448",
    "data-name": "\\uC0AC\\uAC01\\uD615 2448",
    width: 18,
    height: 21.45,
    transform: "translate(-0.465)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2446",
    "data-name": "\\uC0AC\\uAC01\\uD615 2446",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4011",
    "data-name": "\\uADF8\\uB8F9 4011",
    transform: "translate(5.465 2.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4010",
    "data-name": "\\uADF8\\uB8F9 4010",
    transform: "translate(-2 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2939",
    "data-name": "\\uD328\\uC2A4 2939",
    d: "M9.012,7.06a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,9.012,7.06Z",
    transform: "translate(1.628 0.691)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2940",
    "data-name": "\\uD328\\uC2A4 2940",
    d: "M12.675,6.712a5.963,5.963,0,0,0-11.925,0,6.654,6.654,0,0,0,.9,3.138l4.8,8.829c.17.314.448.313.617,0L11.7,9.967A6.4,6.4,0,0,0,12.675,6.712Z",
    transform: "translate(1.823 0.893)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMap);
export default __webpack_public_path__ + "static/media/icoMap.5f6a8b857091a92e6fb525679315480f.svg";
export { ForwardRef as ReactComponent };